
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[category_slug]",
      function () {
        return require("private-next-pages/[category_slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[category_slug]"])
      });
    }
  